export const BILLING_OPTIONS = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
];

export const DEFAULT_SLOT = {
    start: "18:00",
    end: "18:30",
    quantity: 1,
};

export function parseScheduleSlot(value) {
    const parts = value?.split(" - ") || [];
    const start = (parts[0] || "").trim();
    const end = (parts[1] || "").trim();
    const quantity = parseInt((parts[2] || "1").match(/\d+/)?.[0] || "1", 10);

    return {
        start,
        end,
        quantity: Number.isNaN(quantity) ? 1 : Math.min(Math.max(quantity, 1), 4),
    };
}

export function formatScheduleSlot(start, end, quantity) {
    return `${start} - ${end} - ${quantity}`;
}

const TIME_PATTERN = /^\d{2}:\d{2}$/;

export function isScheduleSlotComplete(value) {
    const { start, end } = parseScheduleSlot(value);
    return TIME_PATTERN.test(start) && TIME_PATTERN.test(end);
}

export function isScheduleSlotEndBeforeStart(value) {
    if (!isScheduleSlotComplete(value)) {
        return false;
    }

    const { start, end } = parseScheduleSlot(value);
    const [startHour, startMinute] = start.split(":").map(Number);
    const [endHour, endMinute] = end.split(":").map(Number);

    if ([startHour, startMinute, endHour, endMinute].some(Number.isNaN)) {
        return false;
    }

    return endHour * 60 + endMinute <= startHour * 60 + startMinute;
}

export function isValidScheduleSlot(value) {
    return isScheduleSlotComplete(value) && !isScheduleSlotEndBeforeStart(value);
}

export function createDefaultSlot() {
    return formatScheduleSlot(DEFAULT_SLOT.start, DEFAULT_SLOT.end, DEFAULT_SLOT.quantity);
}

export function normalizeScheduleSlot(value) {
    if (!value) {
        return createDefaultSlot();
    }

    const { start, end, quantity } = parseScheduleSlot(value);
    if (!/^\d{2}:\d{2}$/.test(start) || !/^\d{2}:\d{2}$/.test(end)) {
        return createDefaultSlot();
    }

    return formatScheduleSlot(start, end, quantity);
}
